import { loseWeightPageTitle, smokeFreePageTitle } from "../Programme";

export const pageTitleSuffix = "Eligibility checker | Sign up | Gloji";

export const loseWeightPageTitleSuffix = `${loseWeightPageTitle} | ${pageTitleSuffix}`;

export const smokeFreePageTitleSuffix = `${smokeFreePageTitle} | ${pageTitleSuffix}`;
